import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../components/pdf/fontstyles';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    lineHeight: 1.4,
    fontFamily: 'Helvetica',
    ...style.marathi,
  },
  header: {
    marginBottom: 15,
    textAlign: 'center',
    borderBottom: '1pt solid #000',
    paddingBottom: 10
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 8,
    marginBottom: 10,
    textTransform: 'uppercase'
  },
  subtitle: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 2
  },
  reference: {
    fontSize: 10,
    textAlign: 'left'
  },
  personalInfoContainer: {
    flexDirection: 'row',
    marginBottom: 15,
    justifyContent: 'space-between'
  },
  personalInfoColumn: {
    width: '48%'
  },
  infoRow: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'center'
  },
  infoLabel: {
    width: '30%',
    fontWeight: 'bold'
  },
  infoValue: {
    width: '70%',
    borderBottom: '1pt solid #000',
    paddingBottom: 3
  },
  // Table styles
  table: {
    width: '100%',
    border: '1pt solid #000',
    marginTop: 15,
    marginBottom: 20
  },
  tableHeader: {
    backgroundColor: '#f0f0f0',
    flexDirection: 'row',
    borderBottom: '1pt solid #000'
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1pt solid #000',
    minHeight: 10
  },
  tableCol: {
    padding: '6pt 3pt',
    borderRight: '1pt solid #000',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tableHeaderText: {
    fontWeight: 'bold',
    fontSize: 9,
    textAlign: 'center'
  },
  remarkColumn: {
    width: '20%',
    padding: 10,
    borderRight: '1pt solid #000',
    minHeight: 25 
  },
  // Column widths
  srNoCol: { width: '5%' },
  institutionCol: { width: '15%' },
  reasonCol: { width: '10%' },
  dateCol: { width: '8%' },
  breakCol: { width: '8%' },
  periodCol: { width: '8%' },
  interventionCol: { width: '12%' },
  anotherSchoolCol: { width: '12%' },
  condonedCol: { width: '8%' },
  dutyPeriodCol: { width: '8%' }
});

const Break = ({ result }) => {
  const rows = [
    { // Row 1
      srNo: '1',
      institution: '2',
      reason: '3',
      startDate: '3',
      endDate: '4',
      totalPeriod: '5',
      intervention: '6',
      anotherSchool: '7',
      condoned: '8',
      dutyPeriod: '9'
    },
    { // Row 2
      srNo: '2',
      institution: 'Nil',
      reason: 'Nil',
      startDate: 'Nil',
      endDate: 'Nil',
      totalPeriod: 'Nil',
      intervention: 'Nil',
      anotherSchool: 'Nil',
      condoned: 'Nil',
      dutyPeriod: 'Nil'
    },
    // { // Row 3 (will have big vertical space)
    //   srNo: '',
    //   institution: '',
    //   reason: '',
    //   startDate: '',
    //   endDate: '',
    //   totalPeriod: '',
    //   intervention: '',
    //   anotherSchool: '',
    //   condoned: '',
    //   dutyPeriod: ''
    // }
  ];

  const remarkText = `There is no break in the entire service of ${result.employeeName} during her service beginning from ${result.dateOfAppointment} to ${result.dateOfRetirement}`;

  return (
    <View size="A4" orientation='landscape' style={styles.page}>
      {/* Header Section */}
      <View style={styles.header}>
        <Text style={styles.subtitle}>Pension Scheme for Teaching and Non-Teaching Staff</Text>
        <Text style={styles.subtitle}>Non-Government Aided College and Non-Agricultural University</Text>
        <Text style={[styles.title]}>
          Service Break
        </Text>
        <Text style={styles.subtitle}>
          Statement showing the break in service of Shri/Smt. {result.employeeName}, Designation: {result.designation}
        </Text>
      </View>

      {/* Personal Information Section */}
      <View style={styles.personalInfoContainer}>
        <View style={styles.personalInfoColumn}>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Name of College:</Text>
            <Text style={styles.infoValue}>{result.institutionName}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Date of Birth:</Text>
            <Text style={styles.infoValue}>{result.dateOfBirth}</Text>
          </View>
        </View>
        <View style={styles.personalInfoColumn}>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Date of Appointment:</Text>
            <Text style={styles.infoValue}>{result.dateOfAppointment}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Date of Retirement:</Text>
            <Text style={styles.infoValue}>{result.dateOfRetirement}</Text>
          </View>
        </View>
      </View>

      {/* Service History Table */}
      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableHeader}>
          <View style={[styles.tableCol, styles.srNoCol]}>
            <Text style={styles.tableHeaderText}>Sr. No.</Text>
          </View>
          <View style={[styles.tableCol, styles.institutionCol]}>
            <Text style={styles.tableHeaderText}>Institution</Text>
          </View>
          <View style={[styles.tableCol, styles.reasonCol]}>
            <Text style={styles.tableHeaderText}>Reason</Text>
          </View>
          <View style={[styles.tableCol, styles.dateCol]}>
            <Text style={styles.tableHeaderText}>Start Date</Text>
          </View>
          <View style={[styles.tableCol, styles.breakCol]}>
            <Text style={styles.tableHeaderText}>End Date</Text>
          </View>
          <View style={[styles.tableCol, styles.periodCol]}>
            <Text style={styles.tableHeaderText}>Total Period</Text>
          </View>
          <View style={[styles.tableCol, styles.interventionCol]}>
            <Text style={styles.tableHeaderText}>Not Intervened</Text>
          </View>
          <View style={[styles.tableCol, styles.anotherSchoolCol]}>
            <Text style={styles.tableHeaderText}>Followed by Another School</Text>
          </View>
          <View style={[styles.tableCol, styles.condonedCol]}>
            <Text style={styles.tableHeaderText}>Condoned</Text>
          </View>
          <View style={[styles.tableCol, styles.dutyPeriodCol]}>
            <Text style={styles.tableHeaderText}>Duty Period</Text>
          </View>
          <View style={styles.remarkColumn}>
            <Text style={styles.tableHeaderText}>Remarks</Text>
          </View>
        </View>

        {/* Table Rows */}
        {rows.map((row, index) => (
          <View 
            style={[
              styles.tableRow, 
              index === 2 ? { minHeight: 100 } : {} // Big space for row 3
            ]} 
            key={index}
          >
            <View style={[styles.tableCol, styles.srNoCol]}>
              <Text>{row.srNo}</Text>
            </View>
            <View style={[styles.tableCol, styles.institutionCol]}>
              <Text>{row.institution}</Text>
            </View>
            <View style={[styles.tableCol, styles.reasonCol]}>
              <Text>{row.reason}</Text>
            </View>
            <View style={[styles.tableCol, styles.dateCol]}>
              <Text>{row.startDate}</Text>
            </View>
            <View style={[styles.tableCol, styles.breakCol]}>
              <Text>{row.endDate}</Text>
            </View>
            <View style={[styles.tableCol, styles.periodCol]}>
              <Text>{row.totalPeriod}</Text>
            </View>
            <View style={[styles.tableCol, styles.interventionCol]}>
              <Text>{row.intervention}</Text>
            </View>
            <View style={[styles.tableCol, styles.anotherSchoolCol]}>
              <Text>{row.anotherSchool}</Text>
            </View>
            <View style={[styles.tableCol, styles.condonedCol]}>
              <Text>{row.condoned}</Text>
            </View>
            <View style={[styles.tableCol, styles.dutyPeriodCol]}>
              <Text>{row.dutyPeriod}</Text>
            </View>
            {/* Remark column spans all rows */}
            <View style={[
              styles.remarkColumn,
              index === 1 ? { justifyContent: 'flex-start' } : {}
            ]}>
              {index === 1 && (
                <Text style={{ textAlign: 'left' }}>
                  {remarkText}
                </Text>
              )}
            </View>
          </View>
        ))}
      </View>

      {/* Page Number */}
      <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `Page ${pageNumber} of ${totalPages}`
      )} fixed />
    </View>
  );
};

export default Break;